import classNames from 'classnames';
import { RatingButton } from './RatingButton';

type Props = {
  onRating: (rating: number) => void;
  className?: string;
};

const colorRed = 'bg-red-500';
const colorOrange = 'bg-orange-500';
const colorGreen = 'bg-green-500';

const colorRanges = Array(10)
  .fill(true)
  .map((_, i) => {
    const rating = i + 1;
    if (i < 5) {
      return { rating, color: colorRed };
    }
    if (i < 8) {
      return { rating, color: colorOrange };
    }
    return { rating, color: colorGreen };
  });

export const RatingButtonsArray = ({ onRating, className }: Props) => {
  return (
    <div className={classNames('flex justify-center flex-wrap gap-2', className)}>
      {colorRanges.map((rangeElem) => (
        <RatingButton
          key={rangeElem.rating}
          onClick={() => onRating(rangeElem.rating)}
          className={rangeElem.color}
        >
          {rangeElem.rating}
        </RatingButton>
      ))}
    </div>
  );
};
